import React, { useState, useEffect, useRef } from 'react';
import './AdGate.css';

const AdGate = ({ onUnlock }) => {
    const [timer, setTimer] = useState(5); // 5 seconds mandatory wait
    const [canClose, setCanClose] = useState(false);
    const bannerRef = useRef(null);

    useEffect(() => {
        /* 
        // --- REAL ADSTERRA BANNER INTEGRATION ---
        if (bannerRef.current && !bannerRef.current.firstChild) {
            const conf = document.createElement('script');
            conf.innerHTML = `
                atOptions = {
                    'key' : '530706e63dee8c84063f448a8f811db8',
                    'format' : 'iframe',
                    'height' : 250,
                    'width' : 300,
                    'params' : {}
                };
            `;

            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = "//www.highperformanceformat.com/530706e63dee8c84063f448a8f811db8/invoke.js";

            bannerRef.current.append(conf);
            bannerRef.current.append(script);
        }
        // --- END ---
        */

        if (timer > 0) {
            const interval = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
            return () => clearInterval(interval);
        } else {
            setCanClose(true);
            const autoCloseTimeout = setTimeout(() => {
                onUnlock();
            }, 500); // Small delay for smooth transition
            return () => clearTimeout(autoCloseTimeout);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [timer]);


    const getLoadingMessage = () => {
        const messages = [
            "Optimizing portal view...",
            "Syncing dashboard data...",
            "Loading collaboration assets...",
            "Verifying account permissions...",
            "Initializing secure connection..."
        ];
        // timer goes from 5 down to 1
        if (timer > 0 && timer <= 5) {
            return messages[timer - 1];
        }
        return "Welcome to the portal!";
    };

    return (
        <div className="ad-gate-overlay">
            <div className="ad-gate-container">
                <div className="ad-gate-top-label">
                    <i className="ri-advertisement-line"></i> Sponsored Ad
                </div>

                <div className="banner-ad-wrapper" ref={bannerRef}>
                    {/* Ad injected here */}
                </div>

                <div className="ad-gate-info">
                    <p>{getLoadingMessage()}</p>
                </div>

                <div className="ad-gate-footer">
                    <div className="progress-container">
                        <div
                            className="progress-bar"
                            style={{ width: `${((5 - timer) / 5) * 100}%` }}
                        ></div>
                    </div>
                    <div className="ad-gate-status">
                        {canClose ? 'Portal Ready' : `Loading Portal... ${timer} seconds`}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdGate;
